import { render, staticRenderFns } from "./document-tab.vue?vue&type=template&id=4b9ed837&scoped=true"
import script from "./document-tab.vue?vue&type=script&lang=js"
export * from "./document-tab.vue?vue&type=script&lang=js"
import style0 from "./document-tab.vue?vue&type=style&index=0&id=4b9ed837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ed837",
  null
  
)

export default component.exports